export const getAuthState = (store) => store.auth;
export const getAuthIsLoggedIn = (store) =>
    getAuthState(store) ? getAuthState(store).isLoggedIn : false;
export const getAuthLoading = (store) =>
    getAuthState(store) ? getAuthState(store).loading : false;
export const getAuthHasError = (store) =>
    getAuthState(store) ? getAuthState(store).hasError : false;
